import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

const starsCalculation = (renderStars) => {
  const starsInt = renderStars ? parseFloat((renderStars).toFixed(1)) : 0;
  let stars = [];
  if (0 === starsInt) {
    stars = [];
  } else {
    const halfStar = starsInt - parseInt(starsInt, 10);
    for (let i = 1; i <= starsInt; i++) {
      stars.push('icon-full-star');
    }

    if (0 !== starsInt % 1) {
      if ((0.25 < halfStar) && (0.75 > halfStar)) {
        stars.push('icon-half-star');
      } else if (0.25 > halfStar) {
        stars.push('icon-empty-star');
      } else {
        stars.push('icon-full-star');
      }
    }

    const emptyStars = 5 - starsInt;

    for (let j = 1; j <= emptyStars; j++) {
      stars.push('icon-empty-star');
    }
  }
  return stars;
};

const Stars = ({
  reviewStars,
  reviewCount,
  starClassName = '',
  reviewCountClassName = ''
}) => {
  const starsArray = starsCalculation(reviewStars);
  return (
    <div className="flex middle">
      <div>
        {
          starsArray.map((star, i) => {
            const index = i;
            return <span key={`star-${index}`} className={`ico-md ${star} ${starClassName}`} />;
          })
        }
      </div>
      <div className={classnames('margin-md-left', reviewCountClassName)}>
        <FormattedMessage id="hosting.stars.number_of_reviews" defaultMessage="{reviewCount} reviews" values={{ reviewCount: reviewCount }}/>
      </div>
    </div>
  );
};

Stars.propTypes = {
  reviewStars: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
  starClassName: PropTypes.string,
  reviewCountClassName: PropTypes.string
};

export default Stars;
